import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/Capture1.PNG";
import emotion from "../../Assets/Projects/mobileLogo.png";
import editor from "../../Assets/Projects/foddi.jpeg";
import chatify from "../../Assets/Projects/Capture (1).png";
import suicide from "../../Assets/Projects/Capture3.PNG";
import bitsOfCode from "../../Assets/Projects/Capture.PNG";
import Malaz from "../../Assets/Projects/Malaz.PNG";
import RealState from "../../Assets/Projects/Capture7.PNG";
import revoapps from "../../Assets/Projects/revoapps.jpeg";
import foodApp from "../../Assets/Projects/foodApp.jpeg";
import Courses from "../../Assets/Projects/Courses.png";
import shaheen from "../../Assets/Projects/shaheen.png";
import afaq from "../../Assets/Projects/afaq.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={revoapps}
              isBlog={false}
              title="RevoWoo"
              description="Ecommerce app"
              demoLink="https://play.google.com/store/apps/details?id=com.revoapps.woocommerce"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Courses}
              isBlog={false}
              title="الكورسات المتخصصة"
              description="Courses app"
              demoLink="https://play.google.com/store/apps/details?id=com.church.specializedcourses"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shaheen}
              isBlog={false}
              title="shaheen"
              description="Booking app"
              demoLink="https://shaheen-booking.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={foodApp}
              isBlog={false}
              title="قائمه الطلبات"
              description="food  app"
              demoLink="https://play.google.com/store/apps/details?id=com.menus_page.client"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Tarteeb"
              description="School Mangement"
              demoLink="https://taarteb.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={afaq}
              isBlog={false}
              title="afaq"
              description="School Mangement"
              demoLink="https://afaq-ys7j.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Malaz}
              isBlog={false}
              title="MalazSyria"
              description="RealState application"
              demoLink="https://expo.dev/artifacts/eas/vXb5e96g8rmsYQTq1625Vr.apk"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={RealState}
              isBlog={false}
              title="MalazSyria"
              description="luxe-haven"
              demoLink="https://luxe-haven-nine.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Foodi"
              description="Food delivery system."
              demoLink="https://foodibd.com/"
            />
                      </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Foddi App"
              description="Food delivery system."
              demoLink="https://play.google.com/store/apps/details?id=com.foodiBd&hl=en&pli=1"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="welo"
              description="Sessions with a life coach."
              demoLink="https://welo.app/signin"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="الافندي"
              description="Market application"
              demoLink="https://play.google.com/store/apps/details?id=com.effendi.effendi"             />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="shamdinproperty"
              description="Real state ."
              demoLink="https://www.shamdinproperty.com/"     
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
